import { render, staticRenderFns } from "./MonitorWrapper.vue?vue&type=template&id=cdf47772&"
import script from "./MonitorWrapper.vue?vue&type=script&lang=js&"
export * from "./MonitorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MonitorWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports